"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
function isProduct(object) {
    return checkProduct(object).fulfilled;
}
exports.isProduct = isProduct;
function checkProduct(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return __1.check(object, __1.hasString("name"), __1.hasString("shortName"), __1.hasChoice("type", ["SUBSCRIPTION", "STORAGE_UPGRADE", "TRIAL"]), __1.hasNumber("grade").integer(), __1.hasArray("plans", __1.isRecord(__1.hasString("stripeId"), __1.hasString("name"), __1.hasNumber("grade").integer(), __1.hasChoice("paymentInterval", ["MONTHLY", "YEARLY"]), __1.hasMap("costPerUser", __1.isNumber()))), __1.hasString("stripeId").optional()).withOptions(options).explain();
}
exports.checkProduct = checkProduct;
//# sourceMappingURL=Product.js.map